import { Injectable } from '@angular/core'
import { SidePanelService } from '@tv3/services/utils/side-panel.service'
import { NotesDialogComponent } from './notes-dialog.component'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'

@Injectable()
export class NotesSidePanelService {
  constructor(private sidePanel: SidePanelService) {}

  open(inquiry: Inquiry) {
    return this.sidePanel.openSide(NotesDialogComponent, {
      data: { inquiry },
      panelClass: ['modal-edit-notes', 'modal', 'side-modal-lg', 'right'],
    })
  }
}
